import shortid from "shortid";

export default [
  {
    tagName: "mj-column",
    attributes: {
      width: "100%",
      "vertical-align": "top",
    },
    children: [
      {
        tagName: "mj-product",
        attributes: {
          image: "*|PRODUCT_IMG_SRC|*",
          href: "*|PRODUCT_HREF|*",
          title: "*|PRODUCT_TITLE|*",
          price: "*|PRODUCT_PRICE|*",
          description: "*|PRODUCT_DESC|*",
          layout:
            "image:show,title:show,description:show,price:show,button:show",
          dynamic: true,
          prodstructure: true,
          "image-width": 300,
          "image-alt": "",
          "image-title": "",
          "image-align": "center",
          "title-align": "center",
          "price-align": "center",
          "description-align": "center",
          "button-align": "center",
          "price-suffix": "Kč",
          "button-background-color": "#e85034",
          button: "Více",
          containerWidth: 600,
        },
      },
    ],
    uid: shortid.generate(),
  },
];
